import { render, staticRenderFns } from "./FlightsFilters.vue?vue&type=template&id=c292193e"
import script from "./FlightsFilters.vue?vue&type=script&lang=js"
export * from "./FlightsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCaret: require('/home/forge/farescraper.com/components/IconsCaret.vue').default})
